import React, { useState } from "react";
import TimeSlotSelector from "./slot-block-component";
import BlockedSlotsList from "./blocked_slots_list";
import moment from "moment";

const BlockedSlotManager = ({ employeeId, fetchBlockedSlots, gender }) => {
  const [activeTab, setActiveTab] = useState("add");
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  return (
    <div className="w-full bg-gray-50">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-4 sm:p-6">
        {/* Header + Tabs */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-3">
          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">
              Blocked Slots
            </h2>
            <p className="text-xs text-gray-500 mt-1">
              Manage blocked time slots for this employee.
            </p>
          </div>

          <div className="inline-flex rounded-full bg-gray-50 border border-gray-300 overflow-hidden text-xs sm:text-sm">
            <button
              type="button"
              className={`px-4 py-2 ${
                activeTab === "add"
                  ? "bg-[#7F58E6] text-white"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
              onClick={() => setActiveTab("add")}
            >
              Add Blocked Slots
            </button>
            <button
              type="button"
              className={`px-4 py-2 ${
                activeTab === "list"
                  ? "bg-[#7F58E6] text-white"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
              onClick={() => setActiveTab("list")}
            >
              View / Edit Slots
            </button>
          </div>
        </div>

        {/* Content */}
        {activeTab === "add" ? (
          <TimeSlotSelector
            employeeId={employeeId}
            fetchBlockedSlots={fetchBlockedSlots}
            gender={gender}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        ) : (
          <BlockedSlotsList
            employeeId={employeeId}
            fetchBlockedSlots={fetchBlockedSlots}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        )}
      </div>
    </div>
  );
};

export default BlockedSlotManager;
